














































import { Component, Vue, Ref, Prop } from "vue-property-decorator";

@Component({
    components: {
        FormBase: () => import("../../elements/forms/Base.vue"),
        FormInput: () => import("../../elements/forms/Input.vue")
    }
})
export default class RefreshForm extends Vue {
    @Ref() readonly refreshForm!: FormClass;

    @Ref() readonly deleteForm!: FormClass;

    @Prop() readonly token!: string;

    tab = "refresh";

    successMessage = "";

    payload: { estate_id: string; event: "estate-added" | "estate-deleted"; token: string } = {
        estate_id: "",
        event: "estate-added",
        token: ""
    };

    private submitForm() {
        this.payload.token = this.token;
        this.payload.event = "estate-added";
        // @ts-ignore
        axios
            .post("/api/sweepbright/refresh", this.payload)
            .then((response: any) => {
                this.refreshForm.handleSuccess();
                this.successMessage = response.data;
                this.payload = {
                    estate_id: "",
                    event: "estate-added",
                    token: ""
                };
            })
            .catch((e: any) => this.refreshForm.handleErrors(e.response.data));
    }

    private submitDeleteForm() {
        this.payload.token = this.token;
        this.payload.event = "estate-deleted";
        // @ts-ignore
        axios
            .post("/api/sweepbright/refresh", this.payload)
            .then((response: any) => {
                this.deleteForm.handleSuccess();
                this.successMessage = response.data;
                this.payload = {
                    estate_id: "",
                    event: "estate-deleted",
                    token: ""
                };
            })
            .catch((e: any) => this.deleteForm.handleErrors(e.response.data));
    }
}
